import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { PictoEnum } from '@delmonicos/shared-design-system-react/src/components/picto/picto';
import { ChargePointStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/enums/charge-point-status.enum';

interface GenericConnectorStatus {
  name: string;
  color: string;
  accentVariant: AccentVariantEnum;
  picto: PictoEnum;
}

export const ConnectorStatusMap: Record<ChargePointStatus, string> = {
  [ChargePointStatus.Available]: 'available',
  [ChargePointStatus.Preparing]: 'preparing',
  [ChargePointStatus.Charging]: 'charging',
  [ChargePointStatus.SuspendedEVSE]: 'suspended',
  [ChargePointStatus.SuspendedEV]: 'suspended',
  [ChargePointStatus.Finishing]: 'finishing',
  [ChargePointStatus.Reserved]: 'reserved',
  [ChargePointStatus.Unavailable]: 'unavailable',
  [ChargePointStatus.Faulted]: 'faulted',
};

export const GenericConnectorStatusEnum: Record<
  string,
  GenericConnectorStatus
> = {
  available: {
    name: 'available',
    color: 'bg-surface-success',
    accentVariant: AccentVariantEnum.Available,
    picto: PictoEnum.Available,
  },
  preparing: {
    name: 'preparing',
    color: 'bg-surface-informations',
    accentVariant: AccentVariantEnum.Charging,
    picto: PictoEnum.Preparing,
  },
  charging: {
    name: 'charging',
    color: 'bg-surface-informations',
    accentVariant: AccentVariantEnum.Charging,
    picto: PictoEnum.Charging,
  },
  suspended: {
    name: 'suspended',
    color: 'bg-surface-informations',
    accentVariant: AccentVariantEnum.Charging,
    picto: PictoEnum.Suspended,
  },
  finishing: {
    name: 'finishing',
    color: 'bg-surface-informations',
    accentVariant: AccentVariantEnum.Charging,
    picto: PictoEnum.Charging,
  },
  reserved: {
    name: 'reserved',
    color: 'bg-surface-brand',
    accentVariant: AccentVariantEnum.Primary,
    picto: PictoEnum.Reserved,
  },
  unavailable: {
    name: 'unavailable',
    color: 'bg-surface-secondary',
    accentVariant: AccentVariantEnum.Unavailable,
    picto: PictoEnum.Unavailable,
  },
  faulted: {
    name: 'faulted',
    color: 'bg-surface-error',
    accentVariant: AccentVariantEnum.Faulted,
    picto: PictoEnum.Faulted,
  },
};

const unknownStatus: GenericConnectorStatus = {
  name: 'unknown',
  color: 'bg-surface-secondary',
  accentVariant: AccentVariantEnum.Unavailable,
  picto: PictoEnum.Unavailable,
};

export const mapStatusToGenericConnectorStatus = (
  status?: ChargePointStatus,
): GenericConnectorStatus =>
  (status && GenericConnectorStatusEnum[ConnectorStatusMap[status]]) ||
  unknownStatus;
